module.exports = __webpack_public_path__ + "static/media/byOpponent.b83b0327.jpeg";